import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from "@angular/router";
import { StateService } from "@services/state.service";
import { Observable } from "rxjs";

@Injectable()
export class WhenStateKnown  {
  constructor(private stateService: StateService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean|UrlTree>|Promise<boolean|UrlTree>|boolean|UrlTree {
    return this.stateService.whenStateKnown();
  }
}
